import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useMegaMenuStore = defineStore(
  `mega-menu-${window.store_code}`,
  () => {
    const isMegaMenuOpen = ref(false);

    function openMegaMenu(): void {
      isMegaMenuOpen.value = true;
    }

    function closeMegaMenu(): void {
      isMegaMenuOpen.value = false;
    }

    return {
      isMegaMenuOpen,
      openMegaMenu,
      closeMegaMenu,
    };
  }
);
